import { UseFormReturn } from "react-hook-form";
import { Button, Card, Table } from "react-bootstrap";
import { bfKeyForHelp, numFrmt0Dec } from "../../../modules/common";
import { Colors } from "../../../modules/Colors";
import { BFLType } from "../../../types/DBTables";
import React from "react";
import { IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../../types/BFL/Funktionskontroll";
import { useGlobalData } from "../../GlobalDataProvider";

interface IProps {
  bfName: string;
  driftOptimeringar: any[];
  formHook: UseFormReturn;
}

const DriftOptimeringar = ({ bfName, driftOptimeringar, formHook }: IProps) => {
  const globalData = useGlobalData();
  if (!driftOptimeringar || !driftOptimeringar.length || !globalData) return <></>;
  const showkwhs = driftOptimeringar.find((r) => r.kWhs || r.energiSlag) ? true : false;
  const showÅtgärdad = driftOptimeringar.find((r) => r.VisaÅtgärdad) ? true : false;
  const showMerInfo = driftOptimeringar.find((r) => r.VisaMerInfo) ? true : false;
  const showCategories = true;
  let lastCategory = "";

  return (
    <>
      <Card className="mb-3">
        <Card.Header>DriftOptimeringar</Card.Header>
        <Table bordered hover>
          <thead>
            <tr>
              {globalData.isDebug && <th>Id</th>}
              {showkwhs ? (
                <>
                  <th className="text-nowrap">kWh/år</th>
                  <th className="text-nowrap">Energislag</th>
                </>
              ) : (
                <></>
              )}
              <th>Meddelande driftoptimering</th>
              {showMerInfo && <th style={{ width: 50 }}>Visa</th>}
              {showÅtgärdad && <th style={{ width: 50 }}>Utfört ändring</th>}
            </tr>
          </thead>
          <tbody>
            {driftOptimeringar.map((optimering, index) => (
              <React.Fragment key={(optimering.OverrideBFName || "") + optimering.index + (optimering.variant || "")}>
                {showCategories && lastCategory !== optimering.category && optimering.category && (lastCategory = optimering.category) && (
                  <tr>
                    <th colSpan={10}>{optimering.category}</th>
                  </tr>
                )}
                <tr key={optimering.index} style={{ color: optimering.inverteraTecken ? Colors.RedMedium : Colors.GrayBlack }}>
                  {globalData.isDebug && <td>{(optimering.OverrideBFName || "") + optimering.index + (optimering.variant || "")}</td>}
                  {showkwhs && (
                    <>
                      <td className="text-nowrap" style={{ textAlign: "right", paddingRight: 20 }}>
                        {optimering.kWhs !== undefined && !Number.isNaN(optimering.kWhs) ? numFrmt0Dec.format(optimering.kWhs as number) : ""}
                        <input type="hidden" defaultValue={optimering.kWhs} {...formHook.register("driftOptimeringar." + index + ".kWhs", { value: optimering.kWhs })} />
                      </td>
                      <td className="text-nowrap">
                        {optimering.energiSlag}
                        <input
                          type="hidden"
                          defaultValue={optimering.energiSlag}
                          {...formHook.register("driftOptimeringar." + index + ".energiSlag", { value: optimering.energiSlag })}
                        />
                      </td>
                    </>
                  )}
                  <td>
                    {optimering.message}
                    <input type="hidden" {...formHook.register("driftOptimeringar." + index + ".message", { value: optimering.message })} />
                    {(!showÅtgärdad || !optimering.VisaÅtgärdad) && <input type="hidden" {...formHook.register("driftOptimeringar." + index + ".Åtgärdad", { value: true })} />}
                  </td>
                  {showMerInfo && (
                    <td>
                      {optimering.VisaMerInfo && (
                        <Button
                          style={{ fontSize: "0.8em", minWidth: 70, padding: "5px 0px" }}
                          onClick={() =>
                            PubSub.publish("ShowHelp", bfKeyForHelp[(optimering.OverrideBFName || bfName) as BFLType] + "_OptText" + optimering.index + (optimering.variant || ""))
                          }
                        >
                          Mer info
                        </Button>
                      )}
                    </td>
                  )}
                  {showÅtgärdad && (
                    <td style={{ textAlign: "center" }}>
                      {optimering.VisaÅtgärdad && <input type="checkbox" {...formHook.register("driftOptimeringar." + index + ".Åtgärdad")} className="form-check-input" />}
                    </td>
                  )}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
};

export default DriftOptimeringar;
